import { AnyRouteMatch, createRouter, redirect } from "@tanstack/react-router";
import { TOptions } from "i18next";

import { ActionsType, DBTablesType } from "@libs/authorization";
import { i18n, I18nKeyType } from "@libs/i18n";
import { UserRoleType, UserType } from "@/domain/auth";
import { routeTree } from "@/routeTree.gen";

import { hasPermission } from "./authorization";
import { envVariables } from "./envVariables";

export type RouterContextType = {
  isAuthenticated?: boolean;
  userType: UserType | null;
  userRole: UserRoleType | null;
  userId: string | null;
  campusId: string | null;
};

export const routerInstance = createRouter({
  routeTree,
  context: {
    isAuthenticated: undefined,
    userType: null,
    userRole: null,
    userId: null,
    campusId: null,
  },
});

const getHeaderTitlePrefix = () => {
  const env = envVariables.VITE_ENVIRONMENT;
  switch (env) {
    case "local":
    case "development":
      return "Ramsey Dev";
    case "preview":
      return "Ramsey Preview";
    case "staging":
      return "Ramsey Staging";
    default:
      return "TTCC";
  }
};

export const headWithCustomTitle = (
  i18nKey: I18nKeyType,
  i18nKeyOptions?: TOptions,
): {
  links?: AnyRouteMatch["links"];
  scripts?: AnyRouteMatch["headScripts"];
  meta?: AnyRouteMatch["meta"];
} => {
  const title = i18n.t(i18nKey, i18nKeyOptions);

  return {
    meta: [
      {
        title: `${getHeaderTitlePrefix()} | ${title}`,
      },
    ],
  };
};

export const validateRoutePermission = ({
  context,
  action,
  subject,
  subjectResource,
}: {
  context: RouterContextType;
  action: ActionsType;
  subject: DBTablesType;
  subjectResource?: object;
}) => {
  if (
    context.userRole &&
    !hasPermission({
      action,
      subject,
      subjectResource,
      ...context,
    })
  ) {
    throw redirect({
      to: "/",
    });
  }
};
